import { render, staticRenderFns } from "./ModalShare.vue?vue&type=template&id=0c6afc8e&scoped=true&"
import script from "./ModalShare.vue?vue&type=script&lang=js&"
export * from "./ModalShare.vue?vue&type=script&lang=js&"
import style0 from "./ModalShare.vue?vue&type=style&index=0&id=0c6afc8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6afc8e",
  null
  
)

export default component.exports